import { Route } from 'react-router-dom';
import FuseAdminChargingNetworks from './fuse-admin-charging-networks';
import FuseAdminCredit from './fuse-admin-credit';
import FuseAdminCreditCalculation from './fuse-admin-credit-calculation';
import FuseAdminDashboard from './fuse-admin-dashboard';
import FuseAdminImporter from './fuse-admin-importer';
import FuseAdminPrograms from './fuse-admin-programs';
import FuseAdminReferral from './fuse-admin-referral';
import FuseAdminRemittance from './fuse-admin-remittance';
import FuseAdminReports from './fuse-admin-reports';
import { RequireAuth, UseActiveClient } from '/src/components';
import { RoleTypes } from '/src/lib/models';

export const fuseAdminRoutes: React.ReactElement[] = [
  // Dashboard
  <Route
    path="/fuse-admin"
    element={
      <RequireAuth allowedRoles={[RoleTypes.FuseAdmin]}>
        <UseActiveClient>
          <FuseAdminDashboard />
        </UseActiveClient>
      </RequireAuth>
    }
  />,

  // Credit Pricing
  <Route
    path="/fuse-admin/credit-pricing"
    element={
      <RequireAuth allowedRoles={[RoleTypes.FuseAdmin]}>
        <UseActiveClient>
          <FuseAdminCredit />
        </UseActiveClient>
      </RequireAuth>
    }
  />,

  // Credit Calculation
  <Route
    path="/fuse-admin/credit-calculation"
    element={
      <RequireAuth allowedRoles={[RoleTypes.FuseAdmin]}>
        <UseActiveClient>
          <FuseAdminCreditCalculation />
        </UseActiveClient>
      </RequireAuth>
    }
  />,

  // Programs
  <Route
    path="/fuse-admin/programs"
    element={
      <RequireAuth allowedRoles={[RoleTypes.FuseAdmin]}>
        <UseActiveClient>
          <FuseAdminPrograms />
        </UseActiveClient>
      </RequireAuth>
    }
  />,

  // Reports
  <Route
    path="/fuse-admin/reports"
    element={
      <RequireAuth allowedRoles={[RoleTypes.FuseAdmin]}>
        <UseActiveClient>
          <FuseAdminReports />
        </UseActiveClient>
      </RequireAuth>
    }
  />,

  // Referral Partners
  <Route
    path="/fuse-admin/referral-partners"
    element={
      <RequireAuth allowedRoles={[RoleTypes.FuseAdmin]}>
        <UseActiveClient>
          <FuseAdminReferral />
        </UseActiveClient>
      </RequireAuth>
    }
  />,

  // Remittance
  <Route
    path="/fuse-admin/remittance"
    element={
      <RequireAuth allowedRoles={[RoleTypes.FuseAdmin]}>
        <UseActiveClient>
          <FuseAdminRemittance />
        </UseActiveClient>
      </RequireAuth>
    }
  />,

  // Importer
  <Route
    path="/fuse-admin/importer"
    element={
      <RequireAuth allowedRoles={[RoleTypes.FuseAdmin]}>
        <UseActiveClient>
          <FuseAdminImporter />
        </UseActiveClient>
      </RequireAuth>
    }
  />,

  // Charging Networks
  <Route
    path="/fuse-admin/charging-networks"
    element={
      <RequireAuth allowedRoles={[RoleTypes.FuseAdmin]}>
        <UseActiveClient>
          <FuseAdminChargingNetworks />
        </UseActiveClient>
      </RequireAuth>
    }
  />,
];
